<template>
  <div id="submit_customer_offer" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal" style="background-color: #1a1a1a; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">
        <div class="modal-header border-0 align-items-center pb-2">
          <h4 class="modal-title mx-auto font-size-16 font-weight-bold text-white">Submit Custom Request</h4>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" style="position: absolute; right: 20px; opacity: 0.8; text-shadow: none;">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body text-center pt-0 px-4 pb-4">
          <model-global-message
            :global-errors="globalErrors"
            :message="message"
            @clearMessages="clearMessages()"/>
            
          <div v-if="customRequestOptions && customRequestOptions.length > 0" class="mb-4">
            <h6 class="text-left font-size-14 text-muted mb-3">Pre-defined Options</h6>
            <div class="options-container pr-2 text-left" style="max-height: 220px; overflow-y: auto;">
              <div 
                v-for="(customRequestOption, index) in customRequestOptions" 
                :key="index"
                @click="chosenCustomRequestOption(index)"
                :class="isActive(index) === 'active' ? 'option-active' : 'option-inactive'"
                class="d-flex justify-content-between align-items-center mb-2 px-3 py-2 cursor-pointer"
                style="border-radius: 12px; transition: all 0.2s;"
              >
                <span class="text-white font-size-14" style="overflow-wrap: anywhere; max-width: 70%;">{{ customRequestOption.title }}</span>
                <span class="stella-card-price">${{ customRequestOption.price }}</span>
              </div>
            </div>
          </div>

          <div class="custom-section text-left mt-3">
            <h6 class="font-size-14 text-muted mb-2">Or define your own</h6>
            <required-field v-if="isRequired('requestDescription')"/>
            <p v-if="warningMessage" class="warning-message">{{ warningMessage }}</p>
            <textarea
              class="w-100 mb-3 text-white p-3 font-size-14" rows="3"
              style="background: rgba(255,255,255,0.05) !important; border: 1px solid rgba(255,255,255,0.1); border-radius: 12px; resize: none; outline: none;"
              :placeholder="`Custom ($${minRequired} min required)`"
              v-model="customRequest.requestDescription"
              @click="chosenCustomRequest()"></textarea>

            <template v-if="showSubmitAndPrice">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex flex-column">
                  <span class="text-white mb-1">Offer Price</span>
                  <small class="font-size-10 font-weight-bold" style="color: rgba(255,255,255,0.5);">${{ minRequired }} min required</small>
                </div>
                <div class="d-flex align-items-center" style="width: 140px; background: rgba(255,255,255,0.05) !important; border: 1px solid rgba(255,255,255,0.1); border-radius: 12px; overflow: hidden; transition: all 0.2s;">
                  <span class="text-white pl-3 pr-1 font-weight-bold" style="font-size: 14px;">$</span>
                  <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6"
                         class="border-0 text-white pl-1 py-2 font-size-14 w-100" 
                         onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                         v-model="customRequest.offerPrice" @click="chosenCustomRequest()" style="box-shadow: none; outline: none; background: transparent !important;">
                </div>
              </div>
              
              <required-field v-if="isRequired('offerPrice')"/>
              <span class="text-danger font-size-12 d-block mb-3" v-else-if="isSubmitted && !isOfferPriceValid">Offer price should be more than ${{ minRequired }}</span>
              
              <div class="text-center mt-1 mb-3 d-flex align-items-center justify-content-center" style="color: #929292; font-size: 12px;">
                <span style="font-size: 14px; margin-right: 6px;">✨</span> May contain AI-generated content
              </div>
              <div class="text-center w-100">
                <button
                  class="btn btn-primary-gradient"
                  style="min-width: 160px; border-radius: 12px;"
                  @click="submitCustomRequest()">Submit
                </button>
              </div>
            </template>

            <div class="continue-btn mt-4" v-if="!showSubmitAndPrice">
              <div class="text-center mt-1 mb-3 d-flex align-items-center justify-content-center" style="color: #929292; font-size: 12px;">
                <span style="font-size: 14px; margin-right: 6px;">✨</span> May contain AI-generated content
              </div>
              <div class="text-center w-100">
                <button onclick="$('.modal').modal('hide');$('#finalize_custom_request_modal').modal();"
                        class="btn btn-primary-gradient"
                        style="min-width: 160px; border-radius: 12px;"
                        @click="continueWithCustomRequestOption()">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customerCustomRequestMixin } from "@/mixin/customer-custom-request-mixin";
import { required } from "vuelidate/lib/validators";
import { SERVICE_CONTENT } from "@/properties/micro-service";
import RequiredField from "@/components/module/shared/RequiredField";
import { mapActions } from "vuex";
import GlobalMessage from "@/components/module/shared/GlobalMessage";

export default {
  name: "ModelCustomerCustomRequestSubmit",
  components: { RequiredField, GlobalMessage },
  mixins: [customerCustomRequestMixin],
  data() {
    return {
      minRequired: 0,
      customRequestOptions: [],
      selectedIndex: null,
      showSubmitAndPrice: true,
      warningMessage: '', // Data property for the warning message
      isSubmitted: false // Track if the form has been submitted
    };
  },
  validations: {
    customRequest: {
      requestDescription: { required },
      offerPrice: { required }
    }
  },
  computed: {
    isOfferPriceValid() {
      const validNumberPattern = /^[0-9]*\.?[0-9]+$/;

      if (!validNumberPattern.test(this.customRequest.offerPrice)) {
        return false;
      }

      const offerPrice = parseFloat(this.customRequest.offerPrice);
      const minRequired = parseFloat(this.minRequired);
      return offerPrice >= minRequired;
    },
    isCustomRequest() {
      return !!(this.customRequest.offerPrice || this.customRequest.requestDescription);
    }
  },
  methods: {
    ...mapActions(['setCustomRequestInfluencer', 'setCustomRequestIndex', 'pushGlobalError', 'setWarning']),
    show(influencerId, customerId, minRequired) {
      this.clearMessages();
      this.influencerId = influencerId;
      this.customRequest = {};
      this.customRequest.influencer = { id: influencerId };
      this.customerId = customerId;
      this.minRequired = minRequired;
      this.selectedIndex = null;
      this.showSubmitAndPrice = true;
      $('#submit_customer_offer').modal();
      this.loadCustomRequestOptions();
      this.warningMessage = '';
    },
    resubmitShow(customRequest) {
      let influencerId = customRequest.influencer.id;
      let customerId = customRequest.customer.id;
      let minRequired = customRequest.influencer.customRequestMinPrice;
      this.show(influencerId, customerId, minRequired);
      this.customRequest.requestDescription = customRequest.requestDescription;
      this.customRequest.offerPrice = customRequest.offerPrice;
    },
    simpleShow() {
      $('#submit_customer_offer').modal();
    },
    hide() {
      $('#submit_customer_offer').modal('hide');
    },
    loadCustomRequestOptions() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.influencerId}/custom-request-options/`;
      this.getData(url, (customRequestOptions) => {
        this.customRequestOptions = customRequestOptions;
      });
    },
    chosenCustomRequest() {
      this.showSubmitAndPrice = true;
      this.selectedIndex = null;
      this.setCustomRequestInfluencer(null);
    },
    chosenCustomRequestOption(index) {
      this.selectedIndex = index;
      this.$set(this.customRequest, 'requestDescription', null);
      this.$set(this.customRequest, 'offerPrice', null);
      this.showSubmitAndPrice = false;
      this.isLoading = false;
      this.isSubmitted = false;
      this.setCustomRequestInfluencer(null);
    },
    isActive(index) {
      if (this.isCustomRequest) {
        return '';
      } else if (this.selectedIndex === index) {
        return 'active';
      } else {
        return '';
      }
    },
    submitCustomRequest() {
      this.isSubmitted = true;
      this.$v.$touch();

      // Check if requestDescription exceeds the limit and set warning message
      if (this.customRequest.requestDescription.length > 1000) {
        this.warningMessage = 'Your input exceeds the 1000-character limit.';
        return;
      } else {
        this.warningMessage = '';
      }

      if (this.$v.$invalid || !this.isOfferPriceValid) {
        return;
      }

      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.customerId}/custom-request/`;
      this.postData(url, this.customRequest, (data) => {
        this.hide();
        this.$emit("savedCustomRequest", this.customRequest);
      });
    },
    continueWithCustomRequestOption() {
      let optionId = this.customRequestOptions[this.selectedIndex].id;
      this.customRequest.options = { id: optionId };
      this.$emit("submittedCustomRequestOption", this.customRequest);
    }
  }
}
</script>

<style scoped>
button > span {
  margin-left: 0px;
}

.warning-message {
  color: #ff4b81;
  font-size: 0.9em;
  margin-top: 5px;
}

.options-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.options-container::-webkit-scrollbar {
  width: 6px;
}
.options-container::-webkit-scrollbar-track {
  background: transparent;
}
.options-container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

.option-inactive {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.option-inactive:hover {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.option-active {
  background: rgba(255, 110, 199, 0.15);
  border: 1px solid #ff6ec7;
}

textarea:focus, input:focus {
  border-color: rgba(255, 110, 199, 0.5) !important;
}
.d-flex:focus-within {
  border-color: rgba(255, 110, 199, 0.5) !important;
}

</style>
